<nz-form-label nzFor="key">
	{{label}}
</nz-form-label>
<nz-input-group nzSearch [nzSuffix]="key ? suffix : undefined" [nzAddOnAfter]="after">
	<input [value]="key | questionLabel: ''" nz-input name="key" readonly [placeholder]="placeholder" (click)="select()"/>
</nz-input-group>

<ng-template #suffix>
	<button nz-button nzType="text" (click)="key = null">
		<i-feather name="X"></i-feather>
	</button>
</ng-template>

<ng-template #after>
	<button nz-button nzType="primary" nzSearch (click)="select()">
		<i-feather name="crosshair"></i-feather>
	</button>
</ng-template>